export default __webpack_public_path__ + "static/3_23-0ba093983cac175655bcc93d3bc2fcba.png";